import {$, w} from './constants';
import './collection';
import './collections';
import './contact';
import './general';
import './header';
import './home';
import './product';
import './projects';
import './blog.js';


w.load(() => {
    console.log('Hello world from El Cultivo! --Load');
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');
    setMenuHeight();
})

$(w).on('resize', function(){
	setMenuHeight();
});

/* HEIGHT MENU */
export function setMenuHeight(){
    const $header = $('#header_main');
    let height = $header.outerHeight();
    document.documentElement.style.setProperty('--header-height', `${height}px`);
}
/* END HEIGHT MENU */
